<template>
  <div class="customProgress">
    <var-style-provider :style-vars="styleVars">
      <var-progress
        :value="value"
        :line-width="lineWidth"
        :size="size"
        mode="circle"
        :color="color"
        :indeterminate="true"
      >
        <slot>{{ value }}%</slot>
      </var-progress>
    </var-style-provider>
  </div>
</template>

<script lang="ts" setup>
import { LDTheme } from 'ewi-ui-helpers/types';
import './CustomProgress.scss';

export interface CustomProgressProps {
  value?: number;
  lineWidth?: number;
  size?: number | string;
  color?: string;
  theme?: LDTheme;
}

defineOptions({
  name: 'CustomProgress',
});

const props = withDefaults(defineProps<CustomProgressProps>(), {
  value: 0,
  lineWidth: 4,
  size: 32,
  color: 'var(--color-primary)',
  theme: 'light',
});
const lightTheme = {
  '--progress-track-color': 'transparent',
  '--progress-background': 'var(--SysLightPrimary)',
};

const darkTheme = {
  '--progress-track-color': 'transparent',
  '--progress-background': 'var(--SysDarkPrimary)',
};

const styleVars = ref(props.theme === 'light' ? lightTheme : darkTheme);
</script>
